/*global jQuery*/
/**
 * {{name}}
 * Global JS
 *
 * version: {{version}}
 * file:    {{file}}
 * author:  Squiz Australia
 * change log:
 *     {{date}} - First revision
 */

/*
 * Table of Contents
 *
 * - Global
 * - Modules
{{toc}}
 */
"use strict";
/*
--------------------
Global
--------------------
*/
//  Declare JS Enabled.
$("body")
  .removeClass("no-js")
  .addClass("js-enabled");

/**
 * @description - Function  returns information wether given DOM element is currently in the viewport (with additional offset).
 * @param {DOM element} elem - pass DOM element
 */
const isInViewport = elem => {
  const bounding = elem.getBoundingClientRect();
  const offsetFromTop = 50;
  const offsetFromBottom = 400;
  return (
    bounding.top + offsetFromTop <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.bottom >=
      (window.innerHeight || document.documentElement.clientHeight) -
        offsetFromBottom
  );
};

/**
 * @description - Fallback for older browsers when using object-fit: cover
 *
 * To use it apply class .object-fit-fallback to wrapper of an image you want to make fallback for
 */
if (!Modernizr["object-fit"]) {
  $(".object-fit-fallback").each(function() {
    var $container = $(this),
      imgUrl = $container.find("img").prop("src");
    if (imgUrl) {
      $container
        .css("backgroundImage", "url(" + imgUrl + ")")
        .addClass("compat-object-fit");
    }
  });
}

/**
 * @description - Function for smoothScrolling on homepage
 */
var scroll = new SmoothScroll('a[href="#scrollTo"]', {
  speed: 1000,
  updateURL: false
});

/**
 * @description Polyfill for forEach on IE11
 */
(function() {
  if (!Array.prototype.forEach) {
    Array.prototype.forEach = function(fn, scope) {
      for (var i = 0, len = this.length; i < len; ++i) {
        fn.call(scope, this[i], i, this);
      }
    };
  }

  if (!Array.from) {
    Array.from = function(object) {
      "use strict";
      return [].slice.call(object);
    };
  }
})();

/**
 * @description Polyfill for CustomEvent on Internet Explorer >= 9
 */
(function () {
  if ( typeof window.CustomEvent === "function" ) return false;
  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }
  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent;
})();


/*
--------------------
Modules
--------------------
*/
var globals = {
  languageMapper: {
    "EN": "https://www.woodplc.com/home",
    "ES": "",
    "FR": "https://www.woodplc.com/fr"
  }
}

$('.lang-select-mob').selectric({ 
    disableOnMobile: false, 
    nativeOnMobile: false,
    inheritOriginalWidth: true 
}).on('change', function() {
  var selected = $('.selectric-lang-select-mob .selectric-scroll ul').find('li.selected').data('index');
  var lang = $('.selectric-lang-select-mob .lang-select option:eq('+selected+')').data("lang");
  window.location.href = globals.languageMapper[lang];
});

$('.lang-select-desktop').selectric().on('change', function() {
  var selected = $('.selectric-lang-select-desktop .selectric-scroll ul').find('li.selected').data('index');
  var lang = $('.selectric-lang-select-desktop .lang-select option:eq('+selected+')').data("lang");
  window.location.href = globals.languageMapper[lang];
});

$('.js_lang-select').selectric().on('change', function() {
  window.location.href = $(this).find(':selected').val();
});

